/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Ai_Actions_MoInputs */

const en_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI actions/mo`)
};

const de_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Aktionen/Monat`)
};

const fr_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions IA/mois`)
};

const es_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones IA/mes`)
};

const it_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni AI/mese`)
};

const nl_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-acties/maand`)
};

const pl_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akty AI/miesiąc`)
};

const fi_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-toimet/kk`)
};

const da_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-handlinger/mdr`)
};

const sv_settings_feature_ai_actions_mo = /** @type {(inputs: Settings_Feature_Ai_Actions_MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-aktioner/mån`)
};

/**
* | output |
* | --- |
* | "AI actions/mo" |
*
* @param {Settings_Feature_Ai_Actions_MoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_ai_actions_mo = /** @type {((inputs?: Settings_Feature_Ai_Actions_MoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Ai_Actions_MoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_ai_actions_mo(inputs)
	if (locale === "fr") return fr_settings_feature_ai_actions_mo(inputs)
	if (locale === "es") return es_settings_feature_ai_actions_mo(inputs)
	if (locale === "it") return it_settings_feature_ai_actions_mo(inputs)
	if (locale === "nl") return nl_settings_feature_ai_actions_mo(inputs)
	if (locale === "pl") return pl_settings_feature_ai_actions_mo(inputs)
	if (locale === "fi") return fi_settings_feature_ai_actions_mo(inputs)
	if (locale === "da") return da_settings_feature_ai_actions_mo(inputs)
	if (locale === "sv") return sv_settings_feature_ai_actions_mo(inputs)
	return en_settings_feature_ai_actions_mo(inputs)
});